import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultPrompt: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.common.header.default-prompt',
		defaultMessage:
			'Suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}}',
		description: 'Default prompt in Issue Breakdown if no prompt was entered.',
	},
});
